import {
  ProductFragment,
  ProductVariantChannelListingUpdateMutationVariables,
} from "@dashboard/graphql";

type Variant = NonNullable<ProductFragment["variants"]>[number];

/**
 * Builds the variables for `ProductVariantChannelListingUpdate` that flip a
 * single variant's "available for purchase" flag in one channel. The mutation's
 * add input requires a price, so we resend the listing's current price; returns
 * `null` when the variant has no priced listing in that channel (nothing to
 * gate).
 */
export const buildAvailabilityInput = (
  variant: Variant,
  channelId: string,
  isAvailableForPurchase: boolean,
): ProductVariantChannelListingUpdateMutationVariables | null => {
  const listing = variant.channelListings?.find(l => l.channel.id === channelId);

  if (!listing || listing.price == null) {
    return null;
  }

  return {
    id: variant.id,
    input: [
      {
        channelId,
        price: listing.price.amount,
        isAvailableForPurchase,
      },
    ],
  };
};
